<template>
  <div :class="['v-input', inputSize, invalidInput]">
    <label v-if="label" class="v-input-label" :for="id">
      {{ label }}
    </label>
    <div v-if="isPasswordField" class="v-input-password">
      <input
        :id="id"
        class="v-input-control v-input-control-password"
        :name="name"
        :type="passwordInputType"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
      />
      <button
        type="button"
        class="v-input-password-toggle"
        :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
        @click="showPassword = !showPassword"
      >
        <BaseIcon :icon="showPassword ? 'eye-slash' : 'eye'" size="sm" />
      </button>
    </div>
    <input
      v-else
      :id="id"
      class="v-input-control"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      v-mask="mask ? mask : null"
    />
    <div
      v-if="error && typeof message == 'string'"
      class="v-input-invalid-feedback"
    >
      <span>{{ message }}</span>
    </div>
    <div
      v-if="error && Array.isArray(message)"
      class="v-input-invalid-feedback"
    >
      <span v-for="msg in message" :key="msg">
        {{ msg }}
      </span>
    </div>
  </div>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";

const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
});

export default {
  name: "BaseInput",
  components: {
    BaseIcon
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      required: true,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      default: sizes.MD
    },
    error: {
      type: Boolean
    },
    message: {
      type: [String, Array],
      default: ""
    },
    mask: {
      type: [String, Array],
      default: ""
    },
    showPasswordToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    isPasswordField() {
      return this.type === "password" && this.showPasswordToggle;
    },
    passwordInputType() {
      return this.showPassword ? "text" : "password";
    },
    inputSize() {
      return `v-input-${this.size}`;
    },
    invalidInput() {
      return this.error && "v-input-invalid";
    }
  }
};
</script>
